import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

function onTidioChatApiReady(currentUser) {
  if (currentUser && window?.tidioChatApi) {
    window?.tidioChatApi.setVisitorData({
      distinct_id: currentUser?.id?.uuid,
      name: `${currentUser?.attributes?.profile?.firstName} ${currentUser?.attributes?.profile?.lastName}`,
      email: currentUser?.attributes?.email,
    });
    window.tidioChatApi.on('ready', onTidioChatApiReady);
  }
}

const MainWrapper = ({ children }) => {
  const currentUser = useSelector(s => s.user.currentUser);

  useEffect(() => {
    onTidioChatApiReady(currentUser);
  }, [currentUser?.attributes?.email, window.tidioChatApi]);

  return <div>{children}</div>;
};

export default MainWrapper;
